module.exports = "/_next/static/images/7143da3f82ede005580adaec1cc43931-two-people-looking-md@2x.jpg";